<template>
  <div class="card">
    <div class="card-content">
      <div class="content">
        <h2>ABOUT US</h2>
        <p>Hi there! Welcome to the RandomRoad project! We help people to discover hundreds of amazing street views on our planet by using old good Google Street View.</p>
        <h2 style="margin-top: 1.5em;">HOW DOES IT WORK?</h2>
        <p>That’s simple.</p>
        <p>You see a random view by Google Street View on the display. On the left side, you can find a country and both name and geotag of location. Click the big cursor in the below part of the display for moving in any accessible direction.</p>
        <p>If you want to change a street view - click the Next location road button on the left side of the display, then you’ll see something different.</p>
        <p>So, let’s explore the world!</p>
        <p>Enjoy!</p>
      </div>
    </div>
    <footer class="card-footer">
      <router-link to="/">
        <a href="#" class="card-footer-item">Home Page</a>
      </router-link>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>



// WEBPACK FOOTER //
// src/components/AboutUs.vue